import Vue from "vue";
import { Api } from "../../plugins/api";
import axios from "axios";
import moment from "moment";

//Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

// Mise en place d'axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
Vue.prototype.$http = axios;
//Vue.use(require('vue-moment'));
//Vue.prototype.$LienDocumentRgpe.Lien = process.env.VUE_APP_URL_CNDP;

Vue.prototype.$storeDemandeBourse = {
  TokenExtranet: null,
  DataId: {
    ProgrammeGef: 4096,
    ProgrammeGem: 4097,
    Oui: 4008,
    BrouillonCandidat: 3643,
    ComplementCandidat: 3646,
    DossierRetenu: 3662,
    BoursierFirsi: 3663,
    DossierNonRetenu: 3670,
    Maroc: 1002134,
    France: 1002072,
  },
  Lydexien: false,
  ReadOnly: false,
  ValidInfosPerso: false,
  ValidParcoursCpge: false,
  ValidBaccalaureat: false,
  ValidRevenu: false,
  Headers: [
    "Introduction",
    "Informations personnelles",
    "Parcours académique",
    "Concours grandes écoles ciblés",
    "Situation familiale",
    "Revenus",
    "Pour finir",
  ],
  HeadersProtection: [
    "Introduction",
    "Informations personnelles",
    "Parcours académique",
    "Concours grandes écoles ciblés",
    "Situation familiale",
    "Pour finir",
  ],
  HeadersPasProtection: [
    "Introduction",
    "Informations personnelles",
    "Parcours académique",
    "Concours grandes écoles ciblés",
    "Situation familiale",
    "Revenus",
    "Pour finir",
  ],
  LienDocumentDgi: null,
  LienDocumentSalaire: null,
  DonneesFormulaire: {
    ResumeCandidature: null,
    PublipostageSigne: {
      NomFichier: null,
      DonneePieceJointe: null,
    },
    Photo: {
      NomFichier: null,
      DonneePieceJointe: null,
    },
    CandidatureRenouvellement: null,
    TypeContactAutorise: true,
    BeneficiaireAutreBourse: null,
    AnneeScolaireEnCours: null,
    FormulaireFerme: false,
    Autorise: false,
    EtatDossier: { Id: null, Lang00: null },
    ConditionsGenerales: false,
    AnneeScolaire: null,
    Programmes: null,
    Cni: null,
    Nom: null,
    Prenom: null,
    Cne: null,
    Genre: null,
    DateNaissance: null,
    Nationalite: null,
    AutreNationalite: null,
    Email: null,
    TelMaroc: null,
    TelFrance: null,
    PaysAdrPrincipale: null,
    AdrPrincipale: null,
    CodePostalAdrPrincipale: null,
    VilleAdrPrincipale: null,
    ProvinceMaroc: null,
    RegionMaroc: null,
    PaysAutreAdresse: null,
    AutreAdresse: null,
    CodePostalAutreAdresse: null,
    VilleAutreAdresse: null,
    DepartementFrance: null,
    RegionFrance: null,
    SituationHandicap: null,
    TypeHandicap: [],
    ProtectionSociale: null,
    EtablissementProtectionSociale: null,
    ListeParcoursCpge: [],
    ListeConcoursCibles: [],
    ListeAnnexesFirsi: [],
    NombreTuteurs: 0,
    EtablissementCpge: null,
    TypeBac: null,
    AutreTypeBac: null,
    FiliereBac: null,
    AutreFiliereBac: null,
    AnneeObtentionBac: null,
    Lycee: null,
    NomLyceeAutre: null,
    ListeAutresRevenus: [],
  },
  ListeEtablissementsCpgeEnCours: [],
  ListeEtablissementsCpge: [],
  ListeEtablissementsCpgeLydex: [],
  ListeTousEtablissementsCpge: [],
  Lycee: [],
  LyceeMarocains: [],
  LyceeFrancais: [],

  // Editer le résumé de la candidature
  PubliposterCandidature(token) {
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .get("candidature/publipostage/" + this.DonneesFormulaire.EncryptId);
  },

  // Recupere la liste des candidatures
  GetListe(token) {
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .get("candidature/GetListe");
  },
  // Recupere la liste des annexes FIRSI liées à la demande.
  // Pour une demande existante
  GetListeAnnexesFirsi(token) {
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .get("annexes/RecupererListeAnnexes");
  },
  UploadFichier(annexeDto, token) {
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .post("annexes/UploadFichier", annexeDto);
  },
  DeleteFichier(annexeDto, token) {
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .post("annexes/DeleteFichier", annexeDto);
  },
  // Créer ou modifier une demande
  async EnregistrerDemande(token, demandeBourse) {
    try {
      const reponse = await axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .post("candidature/enregistrerCandidature", demandeBourse);
    
      if(reponse && reponse.status === 200){
        return reponse.data;
      }
      else{
        return "error";
      }
    }
    catch(error){
      console.log("Erreur : ", error);
      return "error";
    }
  },

  // Valider définitivement la demande
  async ValiderDemande(token, demandeBourse) {
    try{
      const reponse = await axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .post("candidature/validerCandidature", demandeBourse);
  
      if(reponse && reponse.status === 200){
        return reponse.data;
      }
      else{
        return "error";
      }
    }
    catch(error){
      console.log("Erreur", error);
      return "error";
    }
  },

  // Recupere la liste des etab CPGE (lydex ou non)
  EtabCPGE(lydex) {
    return Api.get(`candidature/getEtabCpge/` + lydex);
  },

  // Recupere la liste de tous les etab CPGE
  TousEtabCPGE() {
    return Api.get(`candidature/getAllEtabCpge`);
  },

  // Récupère la liste des lycées
  ListeLyceesMarocains() {
    // Lycée marocain
    return Api.get("candidature/GetLycee/" + this.DataId.Maroc);
  },
  // Récupère la liste des lycées
  ListeLyceesFrancais() {
    // Lycée Francais
    return Api.get("candidature/GetLycee/" + this.DataId.France);
  },

  NomEtabCpgeParId(id) {
    return this.ListeTousEtablissementsCpge.find((i) => i.idCrypte == id)
      ?.label;
  },

  // Récupère les programmes disponibles selon le référentiel Lydex
  CheckCni(numeroCni) {
    return Api.get("candidature/checkcni/" + numeroCni);
  },

  ChargementFormulaire(token, nid) {
    if (token) {
      return axios
        .create({
          baseURL: process.env.VUE_APP_BASE_API_URL,
          withCredentials: false,
          headers: {
            Accept: "application/json",
            token: token,
            nid: nid,
          },
        })
        .get("candidature/ChargementFormulaire");
    } else {
      return axios
        .create({
          baseURL: process.env.VUE_APP_BASE_API_URL,
          withCredentials: false,
          headers: {
            Accept: "application/json",
          },
        })
        .get("candidature/ChargementFormulaire");
    }
  },
  async SaveEtape(numEtape) {
    try{
      const reponse = await axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: this.TokenExtranet,
        },
      })
      .post("candidature/SaveEtape/" + numEtape, this.DonneesFormulaire);

      if(reponse && reponse.status === 200){
        return reponse.data;
      }
      else{
        return "error";
      }
    }
    catch(error){
      console.log("Erreur : ", error);
      return "error";
    }
  },

  ConvertDateApiToDateVue(dateApi) {
    if (dateApi) {
      return moment(dateApi, "YYYY-MM-DD[T]hh:mm:ss").format("YYYY-MM-DD");
    } else {
      return null;
    }
  },
  // Mappe la liste des annexes DTO en listeAnnexeFirsi
  MapperAnnexeFirsiDto(listeAnnexes) {
    this.DonneesFormulaire.ListeAnnexesFirsi = [];
    listeAnnexes.forEach((annexe) => {
      var annexeDto = this.elementToAnnexesFirsiDto(annexe);
      this.DonneesFormulaire.ListeAnnexesFirsi.push(annexeDto);
    });
  },
  elementToAnnexesFirsiDto(element) {
    var annexe = {
      Supprimer: false,
      IdCrypte: element.idCrypte,
      Editable: element.editable,
      ObligatoireSoumettre: element.obligatoireSoumettre,
      LabelFormulaire: element.labelFormulaire ?? element.nomDocument?.lang00,
      AnneeScolaire: {
        Id: element.anneeScolaire?.id,
        Lang00: element.anneeScolaire?.lang00,
      },
      ConformiteElectronique: {
        Id: element.conformiteElectronique?.id,
        Lang00: element.conformiteElectronique?.lang00,
      },
      ConformitePhysique: {
        Id: element.conformitePhysique?.id,
        Lang00: element.conformitePhysique?.lang00,
      },
      NatureDocument: {
        Id: element.natureDocument?.id,
        Lang00: element.natureDocument?.lang00,
      },
      NomDocument: {
        Id: element.nomDocument?.id,
        Lang00: element.nomDocument?.lang00,
      },
      NomFichier: element.nomFichier,
      DonneePieceJointe: element.donneePieceJointe,
      NonConformeElectronique: element.nonConformeElectronique,
      NonConformePhysique: element.nonConformePhysique,
      CandidatureBourseId: element.candidatureBourseId,
      PpId: element.ppId,
      TemplateAnnexeFirsi: element.templateAnnexeFirsi,
      TypeDeDocument: {
        Id: element.typeDeDocument?.id,
        Lang00: element.typeDeDocument?.lang00,
      },
      UrlFichier: element.urlFichier,
      Fratrie: element.fratrie,
      SituationFamiliale: element.situationFamiliale,
      Etape: element.etape,
      IndexFratrie: element.indexFratrie,
      IndexSituationFamiliale: element.indexSituationFamiliale,
    };

    return annexe;
  },
  // Mappe le retour de l'api en DonnesFormulaire
  MapperDtoEnDonneesFormulaire(candidatureDto, storeCommun) {
    if (candidatureDto) {
      this.ReadOnly = candidatureDto.readOnly;
      storeCommun.ReadOnly = this.ReadOnly;
      storeCommun.AnneeRevenus = candidatureDto.anneeScolaireAutresRevenus?.lang00;
      this.DonneesFormulaire.Autorise = candidatureDto.autorise;
      this.DonneesFormulaire.FormulaireFerme = candidatureDto.formulaireFerme;
      this.DonneesFormulaire.AnneeScolaire = candidatureDto.anneeScolaire;
      this.DonneesFormulaire.AnneeScolaireEnCours =
        candidatureDto.anneeScolaireEnCours;
      this.DonneesFormulaire.EcoleRetenue = candidatureDto.ecoleRetenue;
      this.DonneesFormulaire.EncryptId = candidatureDto.encryptId;
      this.DonneesFormulaire.PpId = candidatureDto.ppid;
      this.DonneesFormulaire.Erreur = candidatureDto.erreur;
      this.DonneesFormulaire.ConditionsGenerales = true;
      this.DonneesFormulaire.Nom = candidatureDto.nom;
      this.DonneesFormulaire.Prenom = candidatureDto.prenom;
      this.DonneesFormulaire.Lydexien = candidatureDto.lydexien;
      this.DonneesFormulaire.Cni = candidatureDto.cni;
      this.DonneesFormulaire.Cne = candidatureDto.cne;
      this.DonneesFormulaire.Genre = candidatureDto.genre;
      this.DonneesFormulaire.DateNaissance = this.ConvertDateApiToDateVue(
        candidatureDto.dateNaissance
      );
      this.DonneesFormulaire.Nationalite = candidatureDto.nationalite;
      this.DonneesFormulaire.AutreNationalite = candidatureDto.autreNationalite;
      this.DonneesFormulaire.Email = candidatureDto.email;
      this.DonneesFormulaire.TelMaroc = candidatureDto.telMaroc;
      this.DonneesFormulaire.TelFrance = candidatureDto.telFrance;
      this.DonneesFormulaire.PaysAdrPrincipale =
        candidatureDto.paysAdrPrincipale;
      this.DonneesFormulaire.AdrPrincipale = candidatureDto.adrPrincipale;
      this.DonneesFormulaire.CodePostalAdrPrincipale =
        candidatureDto.codePostalAdrPrincipale;
      this.DonneesFormulaire.VilleAdrPrincipale =
        candidatureDto.villeAdrPrincipale;
      this.DonneesFormulaire.ProvinceMaroc = candidatureDto.provinceMaroc;
      this.DonneesFormulaire.RegionMaroc = candidatureDto.regionMaroc;
      this.DonneesFormulaire.PaysAutreAdresse = candidatureDto.paysAutreAdresse;
      this.DonneesFormulaire.AutreAdresse = candidatureDto.autreAdresse;
      this.DonneesFormulaire.CodePostalAutreAdresse =
        candidatureDto.codePostalAutreAdresse;
      this.DonneesFormulaire.VilleAutreAdresse =
        candidatureDto.villeAutreAdresse;
      this.DonneesFormulaire.DepartementFrance =
        candidatureDto.departementFrance;
      this.DonneesFormulaire.RegionFrance = candidatureDto.regionFrance;
      this.DonneesFormulaire.SituationHandicap =
        candidatureDto.situationHandicap;
      Object.assign(
        this.DonneesFormulaire.TypeHandicap,
        candidatureDto.typeHandicap
      );
      this.DonneesFormulaire.ProtectionSociale =
        candidatureDto.protectionSociale;
      this.DonneesFormulaire.EtablissementProtectionSociale =
        candidatureDto.etablissementProtectionSociale;
      this.DonneesFormulaire.TypeBac = candidatureDto.typeBac;
      this.DonneesFormulaire.AutreTypeBac = candidatureDto.autreTypeBac;
      this.DonneesFormulaire.FiliereBac = candidatureDto.filiereBac;
      this.DonneesFormulaire.AutreFiliereBac = candidatureDto.autreFiliereBac;
      this.DonneesFormulaire.AnneeObtentionBac =
        candidatureDto.anneeObtentionBac;
      this.DonneesFormulaire.Lycee = candidatureDto.lycee;
      this.DonneesFormulaire.NomLyceeAutre = candidatureDto.nomLyceeAutre;
      this.DonneesFormulaire.AnneeCpge = candidatureDto.anneeCpge;
      this.DonneesFormulaire.FiliereAnnee2 = candidatureDto.filiereAnnee2;
      this.DonneesFormulaire.EtablissementCpge =
        candidatureDto.etablissementCpge;
      this.DonneesFormulaire.BeneficiaireAutreBourse =
        candidatureDto.beneficiaireAutreBourse;
      this.DonneesFormulaire.CandidatureRenouvellement =
        candidatureDto.candidatureRenouvellement;
      this.DonneesFormulaire.Programmes = candidatureDto.programmes;
      this.DonneesFormulaire.EtatDossier.Lang00 =
        candidatureDto.etatDossier?.lang00;
      this.DonneesFormulaire.EtatDossier.Id = candidatureDto.etatDossier?.id;
      this.DonneesFormulaire.AnneeScolaireCpge =
        candidatureDto.anneeScolaireCpge;
      //this.DonneesFormulaire.ConnaissanceFirsi = candidatureDto.connaissanceFirsi;
      this.DonneesFormulaire.Photo = {
        NomFichier: candidatureDto.photo?.nomFichier,
        DonneePieceJointe: candidatureDto.photo?.donneePieceJointe,
        LienSecurisePj: candidatureDto.photo?.lienSecurisePj,
      };

      if (candidatureDto.infosCandidature) {
        storeCommun.ParseInfosCandidature(candidatureDto.infosCandidature);
      }

      if (candidatureDto.autreRevenuDto) {
        storeCommun.ParseAutresRevenusDto(candidatureDto.autreRevenuDto);
      }

      this.LienDocumentDgi = candidatureDto.lienDocumentDgi;
      this.LienDocumentSalaire = candidatureDto.lienDocumentSalaire;

      // this.ReadOnly = ((this.DonneesFormulaire.EtatDossier.Id != this.DataId.BrouillonCandidat && this.DonneesFormulaire.EtatDossier.Id != null && this.DonneesFormulaire.EtatDossier.Id != 0)
      //                 || (this.DonneesFormulaire.EncryptId != null && (this.DonneesFormulaire.Programmes == null || this.DonneesFormulaire.Programmes.length < 1)))
      //                 && !(this.DonneesFormulaire.EtatDossier.Id == this.DataId.ComplementCandidat);
      if (this.DonneesFormulaire.ProtectionSociale == this.DataId.Oui) {
        this.Headers = this.HeadersProtection;
      } else {
        this.Headers = this.HeadersPasProtection;
      }

      // RAZ des listes du formulaire
      this.DonneesFormulaire.ListeParcoursCpge = [];
      this.DonneesFormulaire.ListeConcoursCibles = [];
      storeCommun.ListeAutresRevenus = [];
      storeCommun.ListeFratrie = [];
      storeCommun.ListeSituationsFamiliale = [];
      storeCommun.ListeAutresBourses = [];

      this.MapperAnnexeFirsiDto(candidatureDto.listeAnnexesFirsi);

      // Liste des autres revenus du candidat
      if (candidatureDto.listeAutresRevenus) {
        candidatureDto.listeAutresRevenus.forEach((element) => {
          let revenu = storeCommun.ParseAutreRevenu(element);
          storeCommun.ListeAutresRevenus.push(revenu);
        });
      }

      // Renseigne la liste des autres bourses.
      if (candidatureDto.listeAutresBourses) {
        candidatureDto.listeAutresBourses.forEach((element) => {
          let bourses = storeCommun.ParseBourseDto(element);
          storeCommun.ListeAutresBourses.push(bourses);
        });
      }

      // Renseigne la liste des Parcours CPGE.
      if (candidatureDto.listeParcoursCpge) {
        candidatureDto.listeParcoursCpge.forEach((element) => {
          var parcours = {
            Supprimer: false,
            IdCrypte: element.idCrypte,
            AnneeCpge: element.anneeCpge,
            AnneeScolaire: element.anneeScolaire,
            Filiere: element.filiere,
            Etablissement: element.etablissement,
            TypeEtablissement: element.typeEtablissement,
          };
          this.DonneesFormulaire.ListeParcoursCpge.push(parcours);
        });
      }

      // renseigne la liste des concours grandes ecoles
      if (candidatureDto.listeConcoursCibles) {
        candidatureDto.listeConcoursCibles.forEach((element) => {
          var concours = {
            Supprimer: false,
            IdCrypte: element.idCrypte,
            ConcoursFrancais: element.concoursFrancais,
            ConcoursMarocain: element.concoursMarocain,
            EcoleFrancaise: element.ecoleFrancaise,
            EcoleMarocaine: element.ecoleMarocaine,
          };

          if (concours.ConcoursFrancais) {
            concours.FrancaisOuMarocain = 1;
          } else {
            concours.FrancaisOuMarocain = 2;
          }

          this.DonneesFormulaire.ListeConcoursCibles.push(concours);
        });
      }

      // Liste des fratries
      if (candidatureDto.listeFratries) {
        candidatureDto.listeFratries.forEach((element) => {
          let fratrie = storeCommun.ParseFratrieDto(element);
          storeCommun.ListeFratrie.push(fratrie);
        });
      }

      // Liste des situations familiales
      if (candidatureDto.listeSituationsFamiliale) {
        candidatureDto.listeSituationsFamiliale.forEach((tuteur) => {
          //
          let parents = storeCommun.ParseSituationFamilialeDto(tuteur);
          storeCommun.ListeSituationsFamiliale.push(parents);
        });
      }
      // Fin foreach situation familiale

      storeCommun.CountNombreTuteurs(storeCommun.ListeSituationsFamiliale);
    }
  },
  AffecterStoreCommun(storeCommun) {
    if (storeCommun) {
      this.DonneesFormulaire.ListeFratries = storeCommun.ListeFratrie;
      this.DonneesFormulaire.ListeAutresBourses =
        storeCommun.ListeAutresBourses;
      this.DonneesFormulaire.ListeSituationsFamiliale =
        storeCommun.ListeSituationsFamiliale;
      this.DonneesFormulaire.ListeAutresRevenus =
        storeCommun.ListeAutresRevenus;
      this.DonneesFormulaire.InfosCandidature = storeCommun.InfosCandidature;
      this.DonneesFormulaire.AutreRevenuDto = storeCommun.AutreRevenuDto;
    }
  },
};
